import api from './api'

export const therapyH5VirtualPhoneService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.set('status', params.status)
    if (params.page != null) query.set('page', params.page)
    if (params.size != null) query.set('size', params.size)
    const qs = query.toString()
    return api.get(`/therapy/h5-virtual-phones${qs ? `?${qs}` : ''}`)
  },

  create(label) {
    return api.post('/therapy/h5-virtual-phones', label ? { label } : {})
  },

  regenerateCode(id) {
    return api.post(`/therapy/h5-virtual-phones/${id}/regenerate-code`)
  },

  revoke(id) {
    return api.post(`/therapy/h5-virtual-phones/${id}/revoke`)
  }
}
